module.exports = __webpack_public_path__ + "img/118.0fb8e8b7.png";